/**
 * Author：tanyaohua 2020-05-12
 * discription: 目前网站和客户端有多签操作
 * 在采编中心客户端、网站中点击取消签发，先调用这个方法，在继续取消签发
 */
'use strcit';

angular.module('beforeRetractionModule', [])
    .controller('beforeRetractionCtrl', ['$scope', '$modalInstance', 'callback', 'obj',
        function ($scope, $modalInstance, callback, obj) {
            initStatus();
            initData();

            /**
             * [initStatus description]初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.data = {
                    items: obj.data,
                    selectedArray: obj.selectedArray,
                    datas: [],
                };
            }

            /**
             * [initData description] 初始化数据
             * @return  {[type]}  [return description]
             */
            function initData() {
                beforeHtml();
            }

            /**
             * [beforeHtml description]渲染数组数据
             *
             * @return  {[type]}  [return description]
             */
            function beforeHtml() {
                // 这里把空数据剔除出去
                angular.forEach($scope.data.items, function (item) {
                    if (item.RELATE && item.RELATE.length) {
                        $scope.data.datas.push(item);
                    }
                });
                // 前端匹配标题
                angular.forEach($scope.data.datas, function (item) {
                    for (let i = 0; i < $scope.data.selectedArray.length; i++) {
                        if (item.CHNLDOCID === $scope.data.selectedArray[i].CHNLDOCID) {
                            item.doctitle = $scope.data.selectedArray[i].LISTTITLE || $scope.data.selectedArray[i].TITLE;
                        }
                    }
                });
            }

            /**
             * [cancel description]取消操作
             * @return {[type]} [description]
             */
            $scope.cancel = function () {
                $modalInstance.dismiss();
            };

            /**
             * [isConfirm description]确认取消签发操作
             *
             * @return  {[type]}  [return description]
             */
            $scope.confirm = function() {
                callback();
                $scope.$close();
            };
        },
    ]);
